export enum Products {
    CoreAPI = 1,
    RevenueCycleManagement = 2,
    OnlineAppointmentSystem = 3,
    EligibilityVerification = 4,
    Dashboard = 5,
    PaymentProcessing = 6
}